module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[10]497.26a0269.woff2";